module.exports = __webpack_public_path__ + "media/images/press_kit/azamara/email/top-light-small-ed38cf67969555204848f798d1d6a203.png";